import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetEmployerById = {
  getEmployerById: { data: null, loading: false, error: null },
};

export const getEmployerById = createAsyncThunk('user/getEmployerById', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/employers/${data}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetEmployerById = {
  [getEmployerById.pending]: (state) => {
    state.getEmployerById.loading = true;
    state.getEmployerById.error = null;
  },
  [getEmployerById.fulfilled]: (state, action) => {
    state.getEmployerById.loading = false;
    state.getEmployerById.data = action.payload;
    state.getEmployerById.error = null;
  },
  [getEmployerById.rejected]: (state, action) => {
    state.getEmployerById.loading = false;
    state.getEmployerById.error = action.payload;
  },
};
